import { render, staticRenderFns } from "./CourtLinks.vue?vue&type=template&id=523c7352"
import script from "./CourtLinks.vue?vue&type=script&lang=js"
export * from "./CourtLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports